
import { createRouter, createWebHistory } from 'vue-router';
import AggregatesCrusherRecommender from "./AggregatesCrusherRecommender.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-aggregates-crusher-recommender-app', AggregatesCrusherRecommender, {
  jsonProps: ['mobilityFilters', 'primaryFilters', 'secondaryFilters', 'stationaryFilters', 'mobileProducts', 'stationaryProducts'],
  beforeMount: (el, props) => { },
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});
